import { useEffect } from 'react';

const PostHogAnalytics = () => {
  useEffect(() => {
    // Only initialize PostHog if it hasn't been initialized already
    if (typeof window !== 'undefined' && !window.posthog?.__loaded) {
      try {
        // Initialize PostHog script loader
        !(function (t, e) {
          var o, n, p, r;
          if (e.__SV) return;
          
          window.posthog = e;
          e._i = [];
          e.init = function (i, s, a) {
            function g(t, e) {
              var o = e.split('.');
              2 == o.length && ((t = t[o[0]]), (e = o[1]));
              t[e] = function () {
                t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
              };
            }
            
            // Create script element safely within React lifecycle
            p = t.createElement('script');
            p.type = 'text/javascript';
            p.crossOrigin = 'anonymous';
            p.async = true;
            p.src = s.api_host.replace('.i.posthog.com', '-assets.i.posthog.com') + '/static/array.js';
            
            // Find the first script tag and insert before it
            r = t.getElementsByTagName('script')[0];
            if (r && r.parentNode) {
              r.parentNode.insertBefore(p, r);
            } else {
              // Fallback: append to head if no script tags found
              t.head.appendChild(p);
            }
            
            var u = e;
            for (
              void 0 !== a ? (u = e[a] = []) : (a = 'posthog'),
              u.people = u.people || [],
              u.toString = function (t) {
                var e = 'posthog';
                return 'posthog' !== a && (e += '.' + a), t || (e += ' (stub)'), e;
              },
              u.people.toString = function () {
                return u.toString(1) + '.people (stub)';
              },
              o = 'init me ws ys ps bs capture je Di ks register register_once register_for_session unregister unregister_for_session Ps getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Es $s createPersonProfile Is opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Ss debug xs getPageViewId captureTraceFeedback captureTraceMetric'.split(' '),
              n = 0;
              n < o.length;
              n++
            ) {
              g(u, o[n]);
            }
            e._i.push([i, s, a]);
          };
          e.__SV = 1;
        })(document, window.posthog || []);
        
        // Initialize PostHog with configuration
        window.posthog.init('phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE', {
          api_host: 'https://us.i.posthog.com',
          person_profiles: 'identified_only',
        });
        
        // Mark as loaded to prevent re-initialization
        window.posthog.__loaded = true;
        
        console.log('✅ PostHog Analytics initialized safely in React component');
      } catch (error) {
        console.warn('PostHog initialization failed:', error);
      }
    }
  }, []); // Empty dependency array - run once on mount

  // Return null since this is a utility component
  return null;
};

export default PostHogAnalytics;